import { createContext, ReactNode, useContext, useState } from 'react';

type MapType = 'map' | 'planet';

interface MapViewContextType {
  mapType: MapType;
  setMapType: (type: MapType) => void;
}

const MapViewContext = createContext<MapViewContextType | undefined>(undefined);

export const MapViewProvider = ({ children }: { children: ReactNode }) => {
  const [mapType, setMapType] = useState<MapType>('map');

  return (
    <MapViewContext.Provider value={{ mapType, setMapType }}>
      {children}
    </MapViewContext.Provider>
  );
};

export const useMapViewContext = () => {
  const context = useContext(MapViewContext);
  if (!context) {
    throw new Error('useMapViewContext must be used within a MapViewProvider');
  }
  return context;
};
